<template>
  <div>
    <div class="outmain heighthv pad_20 bor_rad5 ba_f">
      <div class="ba_f">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="学习列表" name="1"></el-tab-pane>
          <el-tab-pane label="题目列表" name="2"></el-tab-pane>
        </el-tabs>
        <div class="t_l mar_b20 mar_t20">
          <el-button type="primary" size="medium" @click="handleEdit">添加题目</el-button>
          <el-button type="primary" size="medium" @click="handleClassify">分类管理</el-button>
          <el-button type="primary" size="medium" @click="exerciseDetail">考试详情</el-button>
        </div>
        <el-table v-loading="listLoading" :element-loading-text="loadingText" :data="list" stripe style="width: 100%" @selection-change="setSelectRows">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="sort" label="排序"></el-table-column>
          <el-table-column prop="title" label="标题"></el-table-column>
          <el-table-column prop="typeName" label="分类"></el-table-column>
          <el-table-column prop="title" label="内容"></el-table-column>
          <el-table-column prop="icon" label="图片">
            <template slot-scope="scope">
              <div class="imgbox">
                <img :src="scope.row.icon" class="tabimg" />
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('common.operation')">
            <template slot-scope="scope">
              <div class="flex">
                <el-button type="text" @click="handleEdit(scope.row)">{{ $t('common.edit') }}</el-button>
                <el-button type="text" @click="handleDelete(scope.row)">{{ $t('common.delete') }}</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="prev, pager, next" :total="page.total" :page-size="page.pagesize" :current-page.sync="page.currentPage" @current-change="handleCurrentChange"></el-pagination>
        <edit ref="edit" @fetchData="fetchData"></edit>
      </div>
    </div>
  </div>
</template>
<script>
import { collegeList, collegeDelete } from '@/api/plugins';
export default {
  data() {
    return {
      list: [],
      formInline: {
        keyword: '',
        vipLabel: '',
        isBlack: '',
        userChannel: '',
        timeData: ''
      },
      form: {},
      activeName: '2',
      listLoading: true,
      dialogVisible: false,
      value: '',
      value1: '',
      startTime: '',
      endTime: '',
      options2: [
        {
          value: '0',
          label: '全部'
        },
        {
          value: '1',
          label: '外卖商家'
        },
        {
          value: '2',
          label: '跑腿商家'
        }
      ],
      options3: [
        {
          value: '0',
          label: '全部'
        },
        {
          value: '1',
          label: '',
        },
        {
          value: '2',
          label: '用户自提'
        }
      ],
      options4: [
        {
          value: '0',
          label: '全部'
        },
        {
          value: '1',
          label: '在线支付'
        },
        {
          value: '2',
          label: '现金支付'
        }
      ],

      // listLoading: true,
      selectRows: '',
      
      page: {
        total: 0,
        size: 10,
        currentPage: 1
      }
    };
  },
  created() {
    this.fetchData();
  },
  computed: {

    loadingText() {

      return this.$t('common.loading');

    },

  },

  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    handleClick() {
      if (this.activeName == '1') {
        this.$router.push({ name: 'learnings' });
      } else {
        this.$router.push({ name: 'exercise' });
      }
    },
    handleClassify() {
      this.$router.push({ name: 'classifylist' });
    },
    onSearch() {},
    setSelectRows(val) {
      this.selectRows = val;
    },
    handleEdit(row) {
      if (row.id) {
        this.$refs['edit'].showEdit(row);
      } else {
        this.$refs['edit'].showEdit();
      }
    },
    handleDelete(row) {
      if (row.id) {
        this.$baseConfirm(this.$t('confirm.deleteItem'), null, async () => {
          const { msg } = await collegeDelete({ id: row.id });
          this.$baseMessage(msg, 'success');
          this.fetchData();
        });
      }
    },
    async fetchData() {
      var params = { page: this.page.currentPage };
      const { data, count } = await collegeList(params);
      this.list = data;
      this.page.total = count;
      this.listLoading = false;
    },
    //考试详情
    exerciseDetail() {
      this.$router.push({ name: 'exerciseDetail' });
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.fetchData();
    }
  }
};
</script>
<style lang="scss" scoped>
.el-dialog__wrapper .el-form-item__content .el-input {
  width: 200px;
  margin-right: 15px;
}
.el-tabs__item {
  font-size: 16px;
}
</style>